// extracted by mini-css-extract-plugin
module.exports = {"boardContainer":"BoardGrid_boardContainer__23AlC","boardGrid":"BoardGrid_boardGrid__318VH"};